import Accordion from '../Accordion';
import { roles } from '../../config/roles';
import { UserCircle } from 'lucide-react';

export default function RolesSection() {
  return (
    <Accordion title="Papéis de Análise" defaultOpen={false}>
      <div className="space-y-4">
        <div className="grid gap-4">
          {roles.map((role) => (
            <div
              key={role.id}
              className="bg-white dark:bg-navy-800 p-4 rounded-xl border border-navy-200 dark:border-navy-700 hover:border-accent-400/50 dark:hover:border-accent-400/30 transition-all duration-200"
            >
              <div className="flex items-start space-x-3">
                <div className="p-2 bg-accent-400/10 dark:bg-accent-400/20 rounded-lg">
                  <UserCircle className="h-5 w-5 text-accent-500 dark:text-accent-400" />
                </div>
                <div>
                  <h3 className="font-semibold text-navy-900 dark:text-navy-50">
                    {role.name}
                  </h3>
                  <p className="text-sm text-navy-500 dark:text-navy-400 mt-1">
                    {role.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Accordion>
  );
}
